<template>
  <div class="topDiv" style="overflow-x: hidden;height:100vh">
    <el-row style="height: 100%;">
      <el-col style="height: 100%;" class="leftMenus" :span="4">
        <CompayMenus :menuIndex="menuIndex" />
      </el-col>
      <el-col :span="20" class="setPadding">
        <el-row class="whiteBox"></el-row>
        <div>
          <div class="mainContent">
            <el-row class="setPageWidth" style="margin-top: -80px;">
              <el-col :span="4" class="positionFont" style="cursor:pointer" @click.native="$router.back()">
                <span class="iconfont">&#xe609;</span>
                <span>返回</span>
              </el-col>
              <el-col :span="20" class="setPageWidth">
                <RightMenus />
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <PcCompanyChat />
              </el-col>
            </el-row>
          </div>
          
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import RightMenus from "@/components/company/RightMenus.vue";
import CompayMenus from "@/components/company/CompayMenus.vue";
import PcCompanyChat from "@/components/company/PcCompanyChat.vue";

export default {
  name: "",
  components: {
    RightMenus,
    CompayMenus,
    PcCompanyChat
  },
  data() {
    return {
      menuIndex: 4,
      sreachValue: "",
      input3: "",
      select: "",
      selectPostion: [
        { label: "全部职位", value: "all" },
        { label: "运营", value: "在职-考虑机会" },
        { label: "当前已发布的所有职位归属", value: "在职-月内到岗" }
      ]
    };
  },
  created: function() {
    this.$emit("headerIsShow", false);
    this.$emit("footerIsShow", false);
  },
  methods: {
    changeClass(index) {
      this.menuIndex = index;
      //加载不同类型残疾人数据
    }
  }
};
</script>
<style lang="stylus" scoped>
.topDiv {
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  height: 100%;
  background-color: #F0F2F5;
  margin: 0 auto;

  .setPadding {
    padding: 0 0 0 260px;
    width: 100%;
  }

  .whiteBox {
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    background: #fff;
    height: 64px;
  }

  .positionFont {
    height: 64px;
    line-height: 64px;
  }

  .sreachHistory {
    width: 1000px;
    height: 130px;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    margin: 40px 0 0 70px;
  }

  .history {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 22px;
    margin-leaf: 2px;
  }

  .leftMenus {
    position: fixed;
    width: 256px;
    height: 100%;
    top: 0;
    z-index: 100;
    box-shadow: 1px 0 5px rgba(0, 0, 0, 0.05);
    background: #252830;
  }

  .sreachInputMargin {
    width: 600px;
  }

  .setPageWidth {
    max-width: 1180px;
    margin: 0 auto;

    .marginTopButton {
      margin: 100px 0 11px 0;
      text-align: center;
      font-size: 18px;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.65);
      line-height: 22px;
    }
  }

  >>>.el-input-group__append, >>>.el-input-group__prepend {
    background-color: #F5F7FA;
    color: #000;
    vertical-align: middle;
    display: table-cell;
    position: relative;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    padding: 0 20px;
    width: 90px;
    white-space: nowrap;

    input::-webkit-input-placeholder {
      color: #000;
    }

    input::-moz-input-placeholder {
      color: #000;
    }

    input::-ms-input-placeholder {
      color: #000;
    }
  }

  >>>.el-input__inner {
    -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #fff;
    box-sizing: border-box;
    color: #000;
    display: inline-block;
    font-size: inherit;
    height: 50px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
  }

  >>>.input-with-select {
    border: 1px solid #fff;
    border-radius: 6px;
    outline: none;
  }

  .sreachButton {
    width: 140px;
    height: 50px;
    background: #f82b18;
    line-height: 50px;
    text-align: center;
    margin-top: 11px;
    color: #fff;
  }

  .mainContent {
    padding: 15px 40px 15px 40px;
    height: 100%;
    position: relative;
    font-size: 18px;
    // line-height: 64px;
    text-align: left;
  }
}
</style>